import React, { useContext } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

import { CreateMeetingContext } from '../../../services/create-meeting/create-meeting.context';
import { ProfileContext } from '../../../services/profile/profile.context';

export const SelectPublicMeeting = () => {
  const { states } = useContext(CreateMeetingContext);
  const { user } = useContext(ProfileContext);
  const { isPublic, setIsPublic } = states;

  const val = {
    false: false,
    true: true,
  };

  const handleChange = (event) => {
    setIsPublic(val[event.target.value]);
  };

  return (
    <>
      <FormControl
        component='fieldset'
        disabled={user && user.is_premium ? false : true}
      >
        <RadioGroup
          name='public'
          value={isPublic.toString()}
          onChange={handleChange}
        >
          <FormControlLabel value='false' control={<Radio />} label='Private' />
          <FormControlLabel
            value='true'
            control={<Radio />}
            label='Public'
            color='primary'
          />
        </RadioGroup>
      </FormControl>
    </>
  );
};
